module.exports = __webpack_public_path__ + "img/check.c70da6ee.png";